import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RouteTitle from '../../../../presentation/RouteTitle';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import EtelAPI from '../../../../api/EtelAPI';
import Overlay from '../../../../presentation/Overlay';
import FileDetailsDialog from './FileDetailsDialog';
import UploadDropZone from './UploadDropZone';
import DeleteDialog from './DeleteDialog';
import LoadingDialog from './LoadingDialog';
import MergeDialog from './MergeDialog';
import UpdateFileDialog from './UpdateFileDialog';

import * as wj from 'wijmo/wijmo.react.grid';
import * as wijmo from 'wijmo/wijmo';
import * as wjcGrid from 'wijmo/wijmo.grid';

// Wijmo Key
wijmo.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);

/**
 * Downloads the selected files' contents.
 *
 * @param {String} content String to write to the file.
 * @param {String} fileName The filename.
 */
function exportFile( content, fileName ) {
  let blob = new Blob( [content], { encoding: 'UTF-8', type: 'text/plain;charset=utf-8' } );
  let element = document.createElement( 'a' );
  element.href = window.URL.createObjectURL( blob );
  element.setAttribute( 'download', fileName );

  element.style.display = 'none';
  document.body.appendChild( element );

  element.click();

  document.body.removeChild( element );
}

class ByFilename extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      view: new wijmo.CollectionView( [] /*, { pageSize: 50 } */ ), // Remove pagination for easier selection
      viewIndex: 0,
      viewCount: 0,
      fileFilter: '',
      userFilter: '',
      action: '',
      mergeDialogFilename: '',
      mergeDialogDescription: '',
      updatedFilename: '',
      updatedDescription: '',
      progress: '',
      descriptions: {},
      users: [],
      actions: [],
      allFiles: [],
      selectedFile: {},
      acceptedFiles: [],
      actionStatus: {
        current: 0,
        total: 0
      },
      showLoadingInsertDialog: false,
      showDownloadingDialog: false,
      showDeletingDialog: false,
      showFilesDialog: false,
      showDeleteFilesDialog: false,
      showMergeDialog: false,
      showMergeLoadingDialog: false,
      showUpdateFileDialog: false
    };

    // Bindable events
    this.onFileFilterChange = this.onFileFilterChange.bind( this );
    this.onUserFilterChange = this.onUserFilterChange.bind( this );
    this.onDescriptionsChange = this.onDescriptionsChange.bind( this );
    this.onActionChange = this.onActionChange.bind( this );
    this.onUpdateFileDialogChange = this.onUpdateFileDialogChange.bind( this );
    this.onMergeDialogChange = this.onMergeDialogChange.bind( this );
    this.onClickApplyUpdateFile = this.onClickApplyUpdateFile.bind( this );
    this.onClickSearchFilter = this.onClickSearchFilter.bind( this );
    this.onClickClearFilter = this.onClickClearFilter.bind( this );
    this.onClickExecute = this.onClickExecute.bind( this );
    this.onClickRemove = this.onClickRemove.bind( this );
    this.onClickUploadFiles = this.onClickUploadFiles.bind( this );
    this.onClickDeleteFiles = this.onClickDeleteFiles.bind( this );
    this.onClickExportFiles = this.onClickExportFiles.bind( this );
    this.onClickMergeFiles = this.onClickMergeFiles.bind( this );
    this.onOpenFileDetailsDialog = this.onOpenFileDetailsDialog.bind( this );
    this.onCloseDialogs = this.onCloseDialogs.bind( this );
    this.onAddFile = this.onAddFile.bind( this );

    // Error handling
    this.onHandleException = this.onHandleException.bind( this );

    // Fields / Properties
    this.wijmoGrid = React.createRef();
    this.wijmoPanel = null;
    this._mounted = false;
    // Current solution seems to be working fine. No need for Python service.
    // this.filepath = '/vfiles/uploadedfiles';
  }

  /**
   * Component has mounted.
   */
  componentDidMount() {
    let { user, auth } = this.props;
    let react_user_id = auth.getProfile( user ).react_user_id;
    let fileParams = [
      { FL_FILE_ID: 0 },
      { FILENAME: '' },
      { REACT_USER_ID: react_user_id }
    ];

    this._mounted = true;

    this.getFiles( fileParams ).then( ( results ) => {
      for ( let r of results ) {
        r.SELECT = false;
      }

      const updatedView = this.state.view;
      updatedView.sourceCollection = results;

      if ( this._mounted ) {
        this.setState( {
          view: updatedView,
          viewIndex: updatedView.pageIndex + 1,
          viewCount: updatedView.pageCount,
          allFiles: results,
          userFilter: react_user_id
        } );
      }
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

    this.getUsers().then( ( result ) => {
      if ( this._mounted ) {
        this.setState( {
          users: result
        } );
      }
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

    this.getActions().then( ( result ) => {
      if ( this._mounted ) {
        this.setState( {
          actions: result
        } );
      }
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  /**
   * Retrieves all of the files that have been uploaded.
   */
  getFiles( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/files' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Retrieves distinct users who are actively using/has file uploads.
   */
  getUsers() {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/users' );

      api.get( [] ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Gets the actions the user can do to the files (delete/merge/rename/export)
   */
  getActions() {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/actions' );

      api.get( [] ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Gets the file contents.
   */
  getFileContents( file ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/contents' );
      const params = [
        { FL_FILE_ID: file.FL_FILE_ID },
        { START: 1 },
        { END: file.COUNT_TOTAL }
      ];

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          this.setState( {
            actionStatus: {
              ...this.state.actionStatus,
              current: this.state.actionStatus.current + 1
            }
          } );

          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Gets the progress for this file when merging files.
   */
  getProgress( params ) {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'filemanagement/byfilename/progress' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Inserts into the table FL_FILE.
   *
   * @param {Object} params Parameters to be used for the insert.
   */
  fl_file_insert( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/flfileinsert' );

      api.insert( params ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Inserts into the table FL_FILE_CONTENTS.
   *
   * @param {Object} params Parameters to be used for the insert.
   */
  fl_file_contents_insert( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/flfilecontentsinsert' );

      api.insert( params ).then( ( results ) => {
        const updatedActionStatus = { ...this.state.actionStatus };
        updatedActionStatus.current += 1;

        this.setState( {
          actionStatus: updatedActionStatus
        } );

        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Inserts into FL_FILE_OPS to be processed by it's specified job...
   *
   * @param {Object} params Parameters to be used for the insert.
   */
  fl_file_ops_insert( params ) {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'filemanagement/byfilename/flfileopsinsert' );

      api.insert( params ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Deletes the file from FL_FILE along with its contents in FL_FILE_CONTENTS.
   *
   * @param {int} fileID The FL_FILE_ID to be deleted in FL_FILE.
   */
  fl_file_delete( fileID ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename' );

      api.delete( fileID ).then( ( results ) => {
        const updatedActionStatus = { ...this.state.actionStatus };
        updatedActionStatus.current += 1;

        this.setState( {
          actionStatus: updatedActionStatus
        } );

        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Updates the filename/description of the a specified file.
   *
   * @param {Object} params Parameters to be used for the update.
   */
  fl_file_update( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename' );

      api.update( params ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Updates the file stats.
   */
  updateFileStats( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/updatefilestats' );

      api.update( params ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Returns user back to the login page if creds fail.
   */
  doLogOff() {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  /**
   * Handles exceptions.
   *
   * @param {Error} e The exception thrown.
   */
  onHandleException( e ) {
    const title = 'File Management';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 410 ) {
      alerts.INFO( title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( title, e.statusText, 5000 );
      this.doLogOff();
    } else if ( status === 400 ) {
      alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      alerts.CRITICAL( title, e );
    }
  }

  /**
   * Deletes selected files.
   *
   * @param {Object} file The file to delete.
   */
  deleteFile( file ) {
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const api = new EtelAPI( 'filemanagement/byfilename' );

    api.delete( file.FL_FILE_ID ).then( ( results ) => {
      const allFiles = [...this.state.allFiles].filter( ( f ) => {
        return f.FL_FILE_ID !== file.FL_FILE_ID;
      } );

      const updatedView = this.state.view;
      updatedView.sourceCollection = allFiles;

      this.setState( {
        allFiles: allFiles,
        view: updatedView,
        action: ''
      }, () => {
        alerts.SUCCESS( 'File Upload', `Successfully deleted ${file.FILENAME}`, 2000 );
      } );
    } ).catch( ( exception ) => {
      alerts.CRITICAL( 'File delete', ' Failed to delete the file.', false );
    } );
  }

  /**
   * Handles the filter of the user select dropdown.
   *
   * @param {Event} event The event of changing the select dropdown.
   */
  onUserFilterChange( event ) {
    this.setState( {
      userFilter: event.target.value,
    } );
  }

  /**
   * Handles the filter of the filename input.
   *
   * @param {Event} event The event of typing into the filename filter input.
   */
  onFileFilterChange( event ) {
    this.setState( {
      fileFilter: event.target.value,
    } );
  }

  /**
   * Handles the update to a description input.
   *
   * @param {Event} event The event of a description input being updated.
   */
  onDescriptionsChange( event ) {
    let newDescriptions = { ...this.state.descriptions };

    newDescriptions[event.target.name] = event.target.value;

    this.setState( {
      descriptions: newDescriptions
    } );
  }

  /**
   * Handles the update for an action selected.
   *
   * @param {Event} event The event of changing to an action.
   */
  onActionChange( event ) {
    this.setState( {
      action: event.target.value,
    } );
  }

  /**
   * Handles the merge dialog's input's change events.
   *
   * @param {Event} event The event of providing a filename/description.
   */
  onMergeDialogChange( event ) {
    this.setState( {
      [event.target.name]: event.target.value
    } );
  }

  /**
   * Handles the Update Files Dialog's input change events.
   *
   * @param {Event} event The event of providing a filename/description.
   */
  onUpdateFileDialogChange( event ) {
    this.setState( {
      [event.target.name]: event.target.value
    } );
  }

  /**
   * Handles the Search/Filter button's click event.
   *
   * @param {Event} event The event of clicking the Search/Filter button.
   */
  onClickSearchFilter( event ) {
    if ( event.key !== 'Enter' && event.target.value !== 'Search' ) {
      return;
    }

    const params = [
      { FL_FILE_ID: 0 },
      { FILENAME: this.state.fileFilter },
      { REACT_USER_ID: this.state.userFilter }
    ];

    this.getFiles( params ).then( ( results ) => {
      for ( let r of results ) {
        r.SELECT = false;
      }

      const updatedView = this.state.view;
      updatedView.sourceCollection = results;

      this.setState( {
        view: updatedView,
        viewIndex: updatedView.pageIndex + 1,
        viewCount: updatedView.pageCount,
        allFiles: results
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  /**
   * Handles the Clear button for the filters. Resets the filters.
   *
   * @param {Event} event The onClick of the Clear button.
   */
  onClickClearFilter( event ) {
    this.getFiles( [] ).then( ( results ) => {
      for ( let r of results ) {
        r.SELECT = false;
      }

      const updatedView = this.state.view;
      updatedView.sourceCollection = results;

      this.setState( {
        view: updatedView,
        viewIndex: updatedView.pageIndex + 1,
        viewCount: updatedView.pageCount,
        allFiles: results,
        userFilter: '',
        fileFilter: ''
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  /**
   * Handles the Execute button's click event.
   *
   * @param {Event} event Execute button's click event.
   */
  onClickExecute( event ) {
    const alerts = new Alerts( this.props.bugsnag, this.props.dispatch );
    const action = this.state.action;
    const selectedFiles = this.state.allFiles.filter( ( file ) => {
      return file.SELECT === true;
    } );

    switch ( action ) {
    case 'DeleteFiles':
      if ( selectedFiles.length > 0 ) {
        this.setState( {
          showDeleteFilesDialog: true
        } );
      }
      break;
    case 'DownloadFiles':
      if ( selectedFiles.length > 0 ) {
        this.onClickExportFiles();
      }
      break;
    case 'MergeFiles':
      if ( selectedFiles.length > 1 ) {
        this.setState( {
          showMergeDialog: true
        } );
      } else {
        alerts.INFO( 'File Merge', 'At least 2 files must be selected for a merge.', false );
      }
      break;
    case 'RenameFile':
      if ( selectedFiles.length === 1 ) {
        this.setState( {
          showUpdateFileDialog: true,
          updatedFilename: selectedFiles[0].FILENAME,
          updatedDescription: selectedFiles[0].DESCRIPTION
        } );
      } else {
        alerts.INFO( 'File Update', 'Only 1 file may be renamed at a time', false );
      }
      break;
    default:
      break;
    }
  }

  /**
   * Click event for the upload files button.
   *
   * @param {Event} event The click event.
   */
  onClickUploadFiles( event ) {
    for ( let f of this.state.acceptedFiles ) {
      this.uploadFiles( f );
    }
  }

  /**
   * Deletes the selected files.
   *
   * @param {Event} event 'Yes' was clicked on the delete dialog to delete
   * the selected files.
   */
  onClickDeleteFiles() {
    const alerts = new Alerts( this.props.bugsnag, this.props.dispatch );
    const selectedFiles = this.state.allFiles.filter( ( file ) => {
      return file.SELECT === true;
    } );

    this.setState( {
      showDeletingDialog: true,
      actionStatus: {
        ...this.state.actionStatus,
        current: 1,
        total: selectedFiles.length
      }
    } );

    for ( let file of selectedFiles ) {
      if ( file.USED_COUNT === 0 ) {
        this.fl_file_delete( file.FL_FILE_ID ).then( ( results ) => {
          alerts.SUCCESS( 'File Upload', `Successfully deleted ${file.FILENAME}`, 2000 );
        } ).catch( ( exception ) => {
          alerts.CRITICAL( 'File Delete', ' Failed to delete the file.', false );
        } );
      } else {
        this.setState( {
          showDeletingDialog: false
        } );

        alerts.CRITICAL( 'File Delete', `Cannot delete ${file.FILENAME} as it is in use.`, false );
      }
    }

    this.setState( {
      showDeleteFilesDialog: false,
      action: ''
    } );
  }

  /**
   * Downloads the selected files.
   */
  onClickExportFiles() {
    const selectedFiles = this.state.allFiles.filter( ( file ) => {
      return file.SELECT === true;
    } );

    this.setState( {
      showDownloadingDialog: true,
      actionStatus: {
        ...this.state.actionStatus,
        current: 1,
        total: selectedFiles.length
      },
      action: ''
    } );

    for ( let i = 0; i < selectedFiles.length; ++i ) {
      let file = selectedFiles[i];
      let filename = file.FILENAME.replace( /[\\/:"*?<>|]+/g, '_' );

      this.getFileContents( file ).then( ( results ) => {
        let content = results.map( ( result ) => {
          return result.NUMBER;
        } ).join( '\n' );

        exportFile( content, filename );
      } );
    }
  }

  /**
   * Merges the selected files.
   */
  onClickMergeFiles() {
    const selectedFiles = this.state.allFiles.filter( ( file ) => {
      return file.SELECT === true;
    } );
    const fileIDs = selectedFiles.map( ( file ) => {
      return file.FL_FILE_ID;
    } ).join();

    let params = {
      FL_FILE_IDS: fileIDs,
      OPERATION: 'MergeFiles',
      DESCRIPTION: this.state.mergeDialogDescription,
      STATUS: 0,
      OUTFILE_NAME: this.state.mergeDialogFilename,
      SPLIT_TYPE: 0,
      SPLIT_COUNT: 0
    };

    this.setState( {
      showMergeLoadingDialog: true,
      progress: 'Processing...'
    } );

    this.fl_file_ops_insert( params ).then( ( results ) => {
      const updatedAllFiles = [...this.state.allFiles];
      const updatedView = this.state.view;
      const result = results.data[0];

      result.SELECT = false;

      updatedAllFiles.unshift( result );
      updatedView.sourceCollection = updatedAllFiles;

      this.setState( {
        allFiles: updatedAllFiles,
        view: updatedView,
        showMergeDialog: false
      }, () => {
        let progressParams = [
          { FL_FILE_ID: selectedFiles[0].FL_FILE_ID }
        ];

        this.checkMergeProgress( progressParams );
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception.statusText );
    } );
  }

  checkMergeProgress( progressParams ) {
    let time = 1;

    this.progressInterval = setInterval( () => {
      this.getProgress( progressParams ).then( ( results ) => {
        let progress = results[0].PROGRESS;
        if ( progress === null || progress === undefined || progress === '' ) {
          this.setState( {
            progress: 'Processing...'
          } );
        } else {
          this.setState( {
            progress: progress
          } );

          if ( progress === 'Complete' ) {
            clearInterval( this.progressInterval );
          }
        }

        // Failsafe to stop the interval if the progress never reached 'Complete'
        ++time;
        if ( time === 90 ) {
          clearInterval( this.progressInterval );
        }
      } ).catch( ( exception ) => {
        clearInterval( this.progressInterval );
        this.onHandleException( exception );
      } );
    }, 1000 );
  }

  /**
   * Updates the selected file's filename/description.
   */
  onClickApplyUpdateFile() {
    const alerts = new Alerts( this.props.bugsnag, this.props.dispatch );

    const selectedFile = this.state.allFiles.filter( ( file ) => {
      return file.SELECT === true;
    } )[0];

    let params = {
      FL_FILE_IDS: selectedFile.FL_FILE_ID,
      OPERATION: 'RenameFile',
      DESCRIPTION: this.state.updatedDescription,
      STATUS: 0,
      OUTFILE_NAME: this.state.updatedFilename,
      SPLIT_TYPE: 0,
      SPLIT_COUNT: 0,
      GetSearchResult: 0
    };

    this.fl_file_ops_insert( params ).then( ( results ) => {
      this.onCloseDialogs();
      alerts.SUCCESS( 'File Update', 'Successfully updated the file.', 2000 );
    } ).catch( ( exception ) => {
      alerts.CRITICAL( 'File Update', exception.statusText, false );
    } );
  }

  /**
   * Handles the event of opening the file details dialog.
   *
   * @param {Event} event Opening of the file details dialog.
   */
  onOpenFileDetailsDialog( event ) {
    const selectedFile = this.wijmoPanel.control.selectedItems[0];

    if ( selectedFile !== undefined ) {
      this.setState( {
        showFilesDialog: true,
        selectedFile: selectedFile
      } );
    }
  }

  /**
   * Handles the closing of any dialogs.
   *
   * @param {Event} event Closing of any dialogs.
   */
  onCloseDialogs( event ) {
    const fileParams = [
      { FL_FILE_ID: 0 },
      { FILENAME: this.state.fileFilter },
      { REACT_USER_ID: this.state.userFilter }
    ];
    const rowSelected = this.wijmoPanel.control.selection.row;

    this.getFiles( fileParams ).then( ( results ) => {
      for ( let r of results ) {
        r.SELECT = false;
      }

      const updatedView = this.state.view;
      updatedView.sourceCollection = results;

      if ( this._mounted ) {
        this.setState( {
          view: updatedView,
          viewIndex: updatedView.pageIndex + 1,
          viewCount: updatedView.pageCount,
          allFiles: results
        }, () => {
          this.wijmoPanel.control.selection = new wjcGrid.CellRange( rowSelected );
        } );
      }
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

    this.setState( {
      showFilesDialog: false,
      showDeleteFilesDialog: false,
      showLoadingInsertDialog: false,
      showDownloadingDialog: false,
      showDeletingDialog: false,
      showMergeDialog: false,
      showMergeLoadingDialog: false,
      showUpdateFileDialog: false,
      actionStatus: {
        current: 0,
        total: 0
      }
    } );
  }

  /**
   * Event of files being added into the DropZone.
   *
   * @param {Array<File>} files The files added into the DropZone.
   */
  onAddFile( files ) {
    /**
     * Verifies if the file is valid -- Only numbers.
     *
     * Numbers will be turned into a set (no duplicates).
     *
     * @param {File} file The file to validate.
     */
    const verifyFiles = ( file ) => {
      const alerts = new Alerts( this.props.bugsnag, this.props.dispatch );
      const reader = new FileReader();

      reader.readAsText( file );
      reader.onload = () => {
        let content = reader.result.replace( /\s/g, '' );
        let contentArr = reader.result.trim().split( '\n' ).map( number => number.trim() );
        let contentSetLength = new Set( contentArr ).size;

        if ( isNaN( content ) ) {
          alerts.WARNING( 'File upload', `Invalid number(s) located in ${file.name}.`, false );
        }

        if ( contentSetLength !== contentArr.length ) {
          alerts.INFO( 'File upload', `Duplicate number(s) located in ${file.name}. Content will be truncated with no duplicates.`, false );
        }
      };
    };

    for ( let i = 0; i < files.length; ++i ) {
      verifyFiles( files[i] );
    }

    this.setState( {
      acceptedFiles: files
    } );
  }

  /**
   * Removes the file from the DropZone.
   *
   * @param {Event} event Click event on the file.
   * @param {String} filename The name of the file to remove.
   */
  onClickRemove( event, filename ) {
    const newFiles = this.state.acceptedFiles.filter( ( file ) => {
      return file.name !== filename;
    } );
    const newDescriptions = { ...this.state.descriptions };
    delete newDescriptions['description-' + filename];

    this.setState( {
      acceptedFiles: newFiles,
      descriptions: newDescriptions
    } );
  }

  /**
   * Attempts to upload the file to the database.
   *
   * @param {File} file The file to upload.
   */
  uploadFiles( file ) {
    const alerts = new Alerts( this.props.bugsnag, this.props.dispatch );
    const reader = new FileReader();

    reader.readAsText( file );

    reader.onabort = () => {
      alerts.CRITICAL( 'File upload', 'Reading was aborted.', false );
    };

    reader.onerror = () => {
      alerts.CRITICAL( 'File upload', 'Error during reading the file.', false );
    };

    reader.onload = () => { };

    reader.onloadend = () => {
      // Split on new lines and remove any whitespace characters
      let content = reader.result.trim().split( '\n' ).map( number => number.trim() );
      // Remove any duplicate numbers. Insert won't work containing duplicates
      let numbers = [...new Set( content )];
      let FL_FILE = {
        FILENAME: file.name,
        DESCRIPTION: this.state.descriptions['description-' + file.name],
        CREATEONDATE: new Date()
      };

      let updatedActionStatus = { ...this.state.actionStatus };
      updatedActionStatus.current = 1;
      updatedActionStatus.total += Math.ceil( numbers.length / 700 );

      this.setState( {
        showLoadingInsertDialog: true,
        actionStatus: updatedActionStatus
      } );

      this.fl_file_insert( FL_FILE ).then( ( fl_file_result ) => {
        let promises = [];

        while ( numbers.length > 0 ) {
          let batch = numbers.splice( 0, 700 ).join( ',' );
          let batchParams = {
            FL_FILE_ID: fl_file_result.data[0].FL_FILE_ID,
            NUMBERS: batch,
            FILENAME: fl_file_result.data[0].FILENAME
          };

          promises.push( this.fl_file_contents_insert( batchParams ) );
        }

        // Promise all of the insertions into FL_FILE_CONTENTS and rerender the inserted file
        Promise.all( promises ).then( ( results ) => {
          const insertedResults = results[0].data[0];
          const allFiles = [...this.state.allFiles];
          const acceptedFiles = [...this.state.acceptedFiles].slice( 1 );
          const newDescriptions = { ...this.state.descriptions };
          const updatedView = this.state.view;

          delete newDescriptions['description-' + file.name];

          // Insert into the front of the list
          allFiles.unshift( insertedResults );
          updatedView.sourceCollection = allFiles;

          this.setState( {
            allFiles: allFiles,
            acceptedFiles: acceptedFiles,
            descriptions: newDescriptions,
            view: updatedView
          }, () => {
            const fileStatsParams = {
              FL_FILE_ID: fl_file_result.data[0].FL_FILE_ID
            };

            // Update the file stats
            this.updateFileStats( fileStatsParams ).then( ( result ) => {
              // No results returned with this proc
            } ).catch( ( exception ) => {
              this.onHandleException( exception );
            } );

            alerts.SUCCESS( 'File Upload', `Successfully uploaded ${file.name}`, 2000 );
          } );
        } ).catch( ( exception ) => {
          alerts.CRITICAL( 'File Content Insertion', ' Failed to upload file contents.', false );
        } );
      } ).catch( ( exception ) => {
        if ( exception.statusText ) {
          alerts.CRITICAL( 'File Insertion', exception.statusText, false );
        } else {
          alerts.CRITICAL( 'File Content Insertion', ' Failed to upload file.', false );
        }
      } );
    };
  }

  /**
   * Updates the wijmo grid/page based on which button is clicked to show the
   * next results.
   *
   * Example taken from:
   * https://www.grapecity.com/wijmo/demos/Core/CollectionView/CreatingViews/Paging/react
   *
   * @param {Object} target The button that was clicked.
   */
  updateViewPager( target ) {
    let view = this.state.view;

    let btn = wijmo.closest( target, 'button' ), id = btn ? btn.id : '';
    switch ( id ) {
    case 'btnFirst':
      view.moveToFirstPage();
      break;
    case 'btnPrev':
      view.moveToPreviousPage();
      break;
    case 'btnNext':
      view.moveToNextPage();
      break;
    case 'btnLast':
      view.moveToLastPage();
      break;
    default:
      break;
    }

    this.setState( {
      viewIndex: view.pageIndex + 1,
      viewCount: view.pageCount
    } );
  }

  /**
   * Renders the header of this component.
   *
   * @returns JSX elements for the header.
   */
  renderHeader() {
    return (
      <div className='file-management-header'>
        <span className='file-management-header-heading'>File Management</span>
        <div className='file-management-search-by-button-group'>
          <button className='file-management-by-filename-button'>Search by Filename</button>
          <button className='file-management-by-dnis-button'>Search by DNIS</button>
        </div>
      </div>
    );
  }

  /**
   * Renders the filter possible filters for this component.
   *
   * @returns JSX elements for the filter.
   */
  renderFilters() {
    const userOptions = this.state.users.map( ( user ) => {
      return <option key={user.REACT_USER_ID} value={user.REACT_USER_ID}>{user.NAME}</option>;
    } );

    return (
      <span className='list-filter' style={{ alignItems: 'center' }}>
        <span className='list-filter-controls file-management-by-filename-filter-controls'>
          <span className='list-filter-control'>
            <label className='list-filter-label'>User</label>
            <select className='list-filter-dropdown' onChange={this.onUserFilterChange} value={this.state.userFilter}>
              <option key='' value=''></option>
              {userOptions}
            </select>
          </span>
          <span className='list-filter-control'>
            <label className='list-filter-label'>Filename</label>
            <input className='list-filter-textbox' type='text' onChange={this.onFileFilterChange} onKeyDown={this.onClickSearchFilter} value={this.state.fileFilter} />
          </span>
        </span>
        <span className='list-filter-search file-management-by-filename-filter-search'>
          <button className='list-filter-search-button' onClick={this.onClickSearchFilter} value='Search'>Search</button>
          <button className='list-filter-clear-button' onClick={this.onClickClearFilter} value='Clear'>Clear</button>
        </span>
      </span>
    );
  }

  /**
   * Renders the wijmo grid that will display the uploaded files.
   *
   * @returns JSX elements for the wijmo grid.
   */
  renderGrid() {
    return (
      <div className='file-management-files-grid-container'>
        <div
          className='file-management-files-grid-item'
          ref={this.wijmoGrid}
          onDoubleClick={this.onOpenFileDetailsDialog}
        >
          <wj.FlexGrid
            ref={( panel ) => {
              this.wijmoPanel = panel; 
            }}
            itemsSource={this.state.view}
            selectionMode='Row'
            style={{ border: 'none', overflow: 'auto' }}
          >
            <wj.FlexGridColumn width='4*' header='Filename' binding='FILENAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='4*' header='Description' binding='DESCRIPTION' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Count' binding='COUNT_TOTAL' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Used' binding='USED_COUNT' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='2*' header='Uses' binding='USES' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Uploaded' binding='UPLOAD_DATE' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Expires' binding='EXPIRE_DATE' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Username' binding='USERNAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' maxWidth={106} header='Select' binding='SELECT' isReadOnly={false} align='center' />
          </wj.FlexGrid>
        </div>
        <div className='file-management-pagination' onClick={e => this.updateViewPager( e.target )}>
          <div id="pager" className="wj-control wj-content wj-pager">
            <div className="wj-input-group">
              <span className="wj-input-group-btn">
                <button id="btnFirst" type="button" className="wj-btn wj-btn-default">
                  <span className="wj-glyph-left"></span>
                  <span className="wj-glyph-left"></span>
                </button>
              </span>
              <span className="wj-input-group-btn">
                <button id="btnPrev" type="button" className="wj-btn wj-btn-default">
                  <span className="wj-glyph-left"></span>
                </button>
              </span>
              <input id="spanCurrent" disabled={true} type="text" className="wj-form-control" value={`${this.state.viewIndex} of ${this.state.viewCount}`} />
              <span className="wj-input-group-btn">
                <button id="btnNext" type="button" className="wj-btn wj-btn-default">
                  <span className="wj-glyph-right"></span>
                </button>
              </span>
              <span className="wj-input-group-btn">
                <button id="btnLast" type="button" className="wj-btn wj-btn-default">
                  <span className="wj-glyph-right"></span>
                  <span className="wj-glyph-right"></span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Renders the footer that contains the ability to upload, delete, merge, or
   * download files.
   *
   * @returns JSX elements for the footer.
   */
  renderFooter() {
    const descriptions = this.state.acceptedFiles.map( ( file ) => {
      return (
        <div className='file-management-footer-description-item' key={'div-' + file.name}>
          <label className='file-management-footer-description-item-label'>{file.name}</label>
          <input className='file-management-footer-description-item-input' name={'description-' + file.name} onChange={this.onDescriptionsChange} />
        </div>
      );
    } );

    const actions = this.state.actions.filter( ( action ) => {
      return action.Visible === 1;
    } ).map( ( action ) => {
      return (
        <option key={action.FL_FILE_ACTIONS_ID} value={action.OPERATION}>{action.DESCRIPTION}</option>
      );
    } );

    return (
      <div className='file-management-footer-container'>
        <span className='file-management-footer-dropzone-container'>
          <span className='file-management-footer-dropzone-grid'>
            <span className='file-management-footer-grid-header'>File Upload</span>
            <UploadDropZone acceptedFiles={this.state.acceptedFiles} onAddFile={this.onAddFile} onClickRemove={this.onClickRemove} />
            <span className='file-management-footer-grid-footer'>Files to upload - {this.state.acceptedFiles.length}</span>
          </span>
        </span>
        <span className='file-management-footer-description-container'>
          <span className='file-management-footer-description-grid'>
            <span className='file-management-footer-grid-header'>Descriptions</span>
            <span className='file-management-footer-description-item-container'>{descriptions}</span>
            <span className='file-management-footer-description-grid-footer'>
              <button className='file-management-buttons' onClick={this.onClickUploadFiles}>Upload Files</button>
            </span>
          </span>
        </span>
        <span className='file-management-footer-action-container'>
          <span className='file-management-footer-description-grid'>
            <span className='file-management-footer-grid-header'>Actions</span>
            <span className='file-management-footer-action-item-container'>
              <label className='file-management-footer-actions-label'>Action for Selected Files:</label>
              <select className='file-management-footer-actions-select' onChange={this.onActionChange} value={this.state.action}>
                <option value=''></option>
                {actions}
              </select>
            </span>
            <span className='file-management-footer-description-grid-footer'>
              <button className='file-management-buttons' onClick={this.onClickExecute}>Execute</button>
            </span>
          </span>
        </span>
      </div>
    );
  }

  /**
   * Renders this component.
   *
   * @returns JSX elements that renders this component.
   */
  render() {
    const selectedFiles = this.state.allFiles.filter( ( file ) => {
      return file.SELECT === true;
    } );

    const deleteOptions = selectedFiles.map( ( file, index ) => {
      return <span key={`selected-${file.FILENAME}-${index}`}>{file.FILENAME}<br /></span>;
    } );

    const showOverlay = this.state.showFilesDialog
      || this.state.showDeleteFilesDialog
      || this.state.showLoadingInsertDialog
      || this.state.showDownloadingDialog
      || this.state.showMergeDialog
      || this.state.showDeletingDialog
      || this.state.showUpdateFileDialog
      || this.state.showMergeLoadingDialog;

    return (
      <span>
        <Overlay show={showOverlay} />
        <FileDetailsDialog
          show={this.state.showFilesDialog}
          onClose={this.onCloseDialogs}
          filedata={this.state.selectedFile}
        />
        <DeleteDialog
          caption={'Delete Selected Files'}
          body={<span>{'Delete selected files:'}<br />{deleteOptions}</span>}
          show={this.state.showDeleteFilesDialog}
          onClose={this.onCloseDialogs}
          onDelete={this.onClickDeleteFiles}
        />
        <LoadingDialog
          show={this.state.showLoadingInsertDialog}
          onClose={this.onCloseDialogs}
          isDone={this.state.actionStatus.current > this.state.actionStatus.total}
          body={`Inserting batch ${this.state.actionStatus.current} of ${this.state.actionStatus.total}`}
        />
        <LoadingDialog
          show={this.state.showDownloadingDialog}
          onClose={this.onCloseDialogs}
          isDone={this.state.actionStatus.current > this.state.actionStatus.total}
          body={`Downloading File ${this.state.actionStatus.current} of ${this.state.actionStatus.total}`}
        />
        <LoadingDialog
          show={this.state.showDeletingDialog}
          onClose={this.onCloseDialogs}
          isDone={this.state.actionStatus.current > this.state.actionStatus.total}
          body={`Deleting File ${this.state.actionStatus.current} of ${this.state.actionStatus.total}`}
        />
        <LoadingDialog
          show={this.state.showMergeLoadingDialog}
          onClose={this.onCloseDialogs}
          isDone={this.state.progress === 'Complete'}
          body={this.state.progress}
        />
        <MergeDialog
          show={this.state.showMergeDialog}
          onClose={this.onCloseDialogs}
          onMerge={this.onClickMergeFiles}
          onInputChange={this.onMergeDialogChange}
        />
        <UpdateFileDialog
          show={this.state.showUpdateFileDialog}
          filename={this.state.updatedFilename}
          description={this.state.updatedDescription}
          onClose={this.onCloseDialogs}
          onApply={this.onClickApplyUpdateFile}
          onInputChange={this.onUpdateFileDialogChange}
        />
        <span className='file-management-by-filename-grid-container'>
          <RouteTitle title={'File Management by Filename'} />
          {this.renderFilters()}
          {this.renderGrid()}
          {this.renderFooter()}
        </span>
      </span>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( ByFilename )
);



// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/ByFilename.js